"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
// reference 'https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js', 'https://github.com/axios/axios/blob/master/lib/utils.js'
var typeChecker_1 = require("./typeChecker");
var forEach = function (obj, fn) {
    if (obj === null || typeof obj === 'undefined') {
        return;
    }
    if (typeof obj !== 'object') {
        return fn.call(null, obj, 0, obj);
    }
    if (typeChecker_1.default.isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i = i + 1) {
            fn.call(null, obj[i], i, obj);
        }
    }
    else {
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                fn.call(null, obj[key], key, obj);
            }
        }
    }
};
var commaEscapeVal = '@:$';
var regExpCommaEscapeVal = /\@\:\$/gi;
var encode = function (val) {
    return encodeURIComponent(val)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%20/g, '+')
        .replace(/%5B/gi, '[')
        .replace(/%5D/gi, ']')
        .replace(/%2C/gi, commaEscapeVal);
};
/*
params = {
   name: ['john','tom','sam']
}
=>
&name=john,tom,sam
 */
exports.paramsSerializer = function (params) {
    var parts = [];
    forEach(params, function (val, key) {
        if (val === null || typeof val === 'undefined') {
            return;
        }
        if (typeChecker_1.default.isArray(val)) {
            var itemsArr_1 = [];
            forEach(val, function (item) {
                if (typeChecker_1.default.isDate(item)) {
                    itemsArr_1.push(encode(item.toISOString()));
                }
                else if (item !== null && typeof item === 'object') {
                    itemsArr_1.push(encode(JSON.stringify(item)));
                }
                else {
                    itemsArr_1.push(encode(item));
                }
            });
            parts.push(encode(key) + '=' + itemsArr_1.join(','));
        }
        else {
            var encodedVal = void 0;
            if (typeChecker_1.default.isDate(val)) {
                encodedVal = encode(val.toISOString());
            }
            else if (val !== null && typeof val === 'object') {
                encodedVal = encode(JSON.stringify(val));
            }
            else {
                encodedVal = encode(val);
            }
            parts.push(encode(key) + '=' + encodedVal);
        }
    });
    return parts.join('&');
};
exports.paramsDeserialize = function (params) {
    var desParams = __assign({}, params);
    for (var key in desParams) {
        if (Object.prototype.hasOwnProperty.call(desParams, key)) {
            if (!desParams[key])
                continue;
            if (desParams[key].includes(',')) {
                desParams[key] = desParams[key].split(',');
            }
            if (desParams[key].includes(commaEscapeVal)) {
                desParams[key] = desParams[key].replace(regExpCommaEscapeVal, ',');
            }
        }
    }
    return desParams;
};
//# sourceMappingURL=paramsSerializer.js.map